import { IonButton, IonIcon, IonLabel, IonRow } from "@ionic/react";
import React, { FC } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../reducers/UserReducer";
import { chevronDown } from "ionicons/icons";

interface IProps {};

const WelcomeRow:FC<IProps> = (props) => {
    const user = useSelector(selectUser)
    let dateTime = new Date()

    const formatDate = () =>{
        const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric', hour:'numeric', minute:'numeric', second:undefined };
        return dateTime.toLocaleTimeString('en-US', options);
    }

    if( !user){
        return null
    }

    return <IonRow className="w-100 ion-justify-content-between">
        <div style={{margin:'1rem'}}>
            <div className="text-dark-blue font-med font-helvetica font-27pt">Welcome back, {user.first_name}</div>
            <div className="text-dark-blue font-med font-helvetica font-14pt" style={{marginTop:'1rem'}}>Your energy performance dashboard</div>
        </div>
        <div style={{display:'flex',alignItems:'center'}}>
            <div style={{display:'flex',alignItems:'center'}}>
                <div className="text-footer-blue font-med font-helvetica font-13pt" style={{marginRight:'2rem'}}>Date Refreshed: {formatDate()}</div>
                <IonButton>
                    <IonLabel className="text-white  font-bold font-helvetica font-10pt" style={{textTransform:'none'}} >Quick Actions</IonLabel>
                    <IonIcon slot='end' src={chevronDown}/>
                </IonButton>
            </div>
        </div>
    </IonRow>
};

export default WelcomeRow;